import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {getFacilities} from "../services/FacilityService";
import {useLogout} from "./useLogout";

// Facility catalog options for one business unit — used by the Facilities multi-select (create-user
// wizard and, later, the user detail screen). No page/size: the picker wants the complete set.
export function useFacilityOptions(businessUnitCode, enabled = true) {
    const [facilities, setFacilities] = useState([]);

    const logout = useLogout();
    const {data, isLoading, isError, error} = useQuery({
        queryKey: ["facilityOptions", businessUnitCode],
        queryFn: () => getFacilities({businessUnitCodes: [businessUnitCode]}),
        enabled: enabled && !!businessUnitCode,
        retry: false,
    });

    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error]);

    useEffect(() => {
        if (data) {
            setFacilities((data.facilities ?? []).map((f) => ({id: f.id, name: f.name})));
        }
    }, [data]);

    return {facilities, isLoading, isError};
}
